import React from "react";
import styles from './Login.module.scss';
import {Button, Grid, TextField} from "@material-ui/core";
import i18n from "../i18n";
import log from "loglevel";
import LogManager from "../common/LogManager";
import SiteAuth from "../common/SiteAuth";
import type { Logger } from "loglevel";

/** Campos del formulario. Las tres estructuras del estado comparten claves. */
type LoginField = 'username' | 'password';

interface LoginState {
    values: Record<LoginField, string>;
    errors: Record<LoginField, boolean>;
    touched: Record<LoginField, boolean>;
}

class Login extends React.Component<object, LoginState> {

    constructor(props: object) {
        super(props);

        this.state = {
            values:  {
                username: '',
                password: '',
            },
            errors:  {
                username: false,
                password: false,
            },
            touched:  {
                username: false,
                password: false,
            },
        }

        this.handleChange = this.handleChange.bind(this);
        this.sendCredentials = this.sendCredentials.bind(this);
    }

    /**
     * Get logger.
     */
    logger(): Logger {
        return log.getLogger('MapComponent');
    }

    handleChange (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                       | React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>): void {
        const field = event.target.name as LoginField;
        const _values = { ...this.state.values };
        _values[field] = event.target.value;
        const _touched = { ...this.state.touched };
        _touched[field] = true;
        const _errors = this.validateField(field, event.target.value);
        this.setState({
            values: _values,
            errors: _errors,
            touched: _touched,
        })
    }

    validateField (fieldName: LoginField, value: string): Record<LoginField, boolean> {
        const errors = { ...this.state.errors };
        errors[fieldName] = value === '';
        return errors;
    }

    async sendCredentials(): Promise<void> {
      SiteAuth.authenticate(this.state.values.username, this.state.values.password)
        .catch((error) => {
          this.logger().debug('Login error', error);
          // @todo Error to show inside the login form or the page.
          LogManager.createError('Usuario o password incorrecto');
        })
    }

    render() {
        return (
            <div
                className={styles.login}
            >
                <Grid container direction="row" justifyContent="center" className={styles.content} >
                    <Grid item xs={10}>
                        <TextField
                            name="username"
                            label="Usuario"
                            type="text"
                            autoComplete="nombre de usuario"
                            fullWidth
                            onChange={this.handleChange}
                            onBlur={this.handleChange}
                            error={this.state.errors.username}
                            defaultValue=""
                        />
                        <TextField
                            name="password"
                            label="Contraseña"
                            type="password"
                            autoComplete="contraseña"
                            fullWidth
                            onChange={this.handleChange}
                            onBlur={this.handleChange}
                            error={this.state.errors.password}
                            defaultValue=""
                        />
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.sendCredentials}
                        disabled={
                            !this.state.touched.username || !this.state.touched.password ||
                            this.state.errors.username || this.state.errors.password
                        }
                    >{ i18n.t('initSession.send') }</Button>
                </Grid>

            </div>
        )
    }
}

export default Login;
